import React from 'react'

const ReplyTo = ({
    replyTo,
    setReplyTo
}) => {
    return (
        replyTo && (
            <div className="ChatUI__reply">
                <div className="reply__title">Ответ на сообщение</div>
                <div className="reply__body">
                    <div className="reply__author">{replyTo.author}</div>
                    <div className="reply__snippet">{replyTo.snippet}</div>
                </div>
                <button className="reply__close" onClick={() => setReplyTo(null)}>✕</button>
            </div>
        )
    )
}

export default ReplyTo